// extracted by mini-css-extract-plugin
export default {"avatarButton":"UserAvatarButton-module__avatarButton--RsYab","avatarImage":"UserAvatarButton-module__avatarImage--ilXZM"};